export default __webpack_public_path__ + "static/media/inter-bold-webfont.d5bf0367.woff2";